var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"ma-0 pa-0",attrs:{"min-width":"400px","max-width":"900px","src":"/img/scn_info.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }